var map = {
	"./forest-poster-mobile.jpg": "dtMk",
	"./ocean-poster-mobile.jpg": "+mYa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r1Jq";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\-poster\-mobile\.jpg$
// module id = r1Jq
// module chunks = 1